import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

import getImagePreview from 'Helpers/Image/ImagePreview';
import PreviewFooterBanner from 'Layout/Footer/PreviewFooterBanner';
import PreviewMidPageBanner from 'Components/Banner/MidPageBanner/PreviewMidPageBanner';
import PreviewSlimBanner from 'Components/Banner/PreviewSlimBanner';
import PreviewTakeOver from 'Components/Banner/PreviewTakeOver';
import PreviewGamesUnderBanner from 'Components/Sales/PreviewGamesUnderBanner';
import PreviewFeaturedCarouselSlide from 'Components/Carousel/PreviewFeaturedCarouselSlide';

const ImagePreviewContainer = ({
  match,
}) => {
  const advertId = match.params.id;
  const [image, setImage] = useState({});

  useEffect(() => {
    const loadAdvert = async () => {
      const data = await getImagePreview(advertId);
      return setImage(data);
    };

    if (advertId) loadAdvert();
  }, [advertId]);

  if (isEmpty(image)) return false;

  if (image.advert_type === 'ProductFooterBanner') {
    return (
      <PreviewFooterBanner footer={image} />
    );
  }

  if (image.advert_type === 'MidPageBanner') {
    return (
      <PreviewMidPageBanner midPageBanner={image} />
    );
  }

  if (image.advert_type === 'SlimBanner') return <PreviewSlimBanner slimBanner={image} />;

  if (image.advert_type === 'TakeOver') {
    return <PreviewTakeOver takeOver={image} />;
  }

  if (image.advert_type === 'GamesUnder') return <PreviewGamesUnderBanner advert={image} />;

  if (image.advert_type === 'v3-Carousel') return <PreviewFeaturedCarouselSlide carousel={image} />;

  return false;
};

ImagePreviewContainer.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
};

export default ImagePreviewContainer;
